import { Box } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import { menuHeaderContainerSx, menuHeaderLogoImgSizeSx } from "../../../styles/globalStyles";

type Props = {
  LogoSrc: string;
  onLogoImgError?: () => void;
  logoSx?: SxProps;
};

export default function MenuHeader({ LogoSrc, onLogoImgError, logoSx }: Props) {
  return (
    <Box sx={menuHeaderContainerSx}>
      <Box
        component="img"
        src={LogoSrc}
        alt="Logo"
        onError={onLogoImgError}
        decoding="async"
        sx={
          {
            ...menuHeaderLogoImgSizeSx,
            ...logoSx,
          } as SxProps
        }
      />
    </Box>
  );
}
